import { jsx as _jsx } from "react/jsx-runtime";
import { BrowserRouter, Router } from 'react-router-dom';
const RouterProvider = ({ history, children }) => {
    if (history) {
        return (_jsx(Router, { location: history.location, navigator: history, children: children }));
    }
    return _jsx(BrowserRouter, { children: children });
};
export default RouterProvider;
